import Drawer from "../../../../components/elements/Drawer";
import OrderDetails from "./OrderDetails.js";

const OrderDetailsDrawer = ({ open, close = () => {}, data = {} }) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl"}
      size={"xl5"}
      title={"Order Details"}
      subtitle=""
      drawerBodyClass="p-2 max-h-[calc(100%-90px)]"
    >
      <div className="h-full overflow-y-auto">
        <OrderDetails close={close} item={data} />
      </div>
    </Drawer>
  );
};

export default OrderDetailsDrawer;
